import {
  ProvisionScheme,
  Scheme,
} from '@app/modules/configuration/configuration.types';

export class SetSchemesAction {
  static type = '[Schemes] SetSchemesAction';
  constructor(public schemes: Scheme[]) {}
}

export class LoadSchemesAction {
  static type = '[Schemes] LoadSchemesAction';
}

export class LoadSchemeAction {
  static type = '[Schemes] LoadSchemeAction';
  constructor(public id: string) {}
}

export class GenerateSchemeAction {
  static type = '[Schemes] GenerateSchemeAction';
  constructor(public scheme: ProvisionScheme) {}
}

export class UpdateSchemeAction {
  static type = '[Schemes] UpdateSchemeAction';
  constructor(public scheme: ProvisionScheme) {}
}

export class ActivateSchemeAction {
  static type = '[Schemes] ActivateSchemeAction';
  constructor(public id: string) {}
}

export class DeactivateSchemeAction {
  static type = '[Schemes] DeactivateSchemeAction';
  constructor(public id: string) {}
}

export class GetSchemeFieldsAction {
  static type = '[Schemes] GetSchemeFieldsAction';
  constructor() {}
}
